import { Box, useTheme } from '@chakra-ui/react';
import { useTableCellContext } from 'components/Table/TableCell/context';
import ProgressBar from './ProgressBar';

const TableCellProgressBar = () => {
  const cellContext = useTableCellContext();

  if (cellContext.cellType === 'progress') {
    const theme = useTheme();

    const { percentile, dataTestId, progressBarColor } = cellContext;

    const valueToUse = percentile || 0;
    return (
      <Box
        display='flex'
        data-testid={dataTestId || 'cjtable-cell-progress-id'}
      >
        <ProgressBar
          progressBarColor={progressBarColor}
          completed={valueToUse * 100}
          percentile={valueToUse}
        >
          <Box
            width='13px'
            height='13px'
            position='absolute'
            right='-12px'
            left={valueToUse === 0 ? 0 : undefined}
            bottom='-5px'
            borderRadius='100%'
            backgroundColor={
              progressBarColor ||
              (valueToUse > 0.5
                ? theme.colors.graphicGreen
                : theme.colors.graphicRed)
            }
          />
        </ProgressBar>
        <Box
          as='span'
          width='24px'
          fontFamily={theme.fonts.light}
          fontSize='12px'
          color={theme.colors.mediumGrey}
          margin='0 15px'
        >
          {valueToUse}
        </Box>
      </Box>
    );
  }
  return null;
};

export default TableCellProgressBar;
